import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-643ba093"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "tab-list font-medium h-4rem font-normal flex align-items-end",
  role: "list"
}

import TabItem from "./TabItem.vue";
import { TabItemType } from "./TabItemType";
import { ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TabList',
  props: {
    model: {},
    active: {}
  },
  emits: ["itemChange"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const active = ref<string | null>(props.active ?? null);

watch(
  () => props.active,
  () => (active.value = props.active)
);

function setActive(item: TabItemType): void {
  active.value = item.id;
  emit("itemChange", item.id);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model, (item) => {
      return (_openBlock(), _createBlock(TabItem, {
        class: "px-4",
        role: "listitem",
        onClick: ($event: any) => (setActive(item)),
        key: item.id,
        item: item,
        active: item.id === active.value
      }, null, 8, ["onClick", "item", "active"]))
    }), 128))
  ]))
}
}

})